import React from 'react'
import PropTypes from 'prop-types'
import './AppItemComponent.css'

function AppItemComponent({ headerImage, children }) {
  return (
    <div className="app-item-component">
      <div className="app-item-header">
        <img src={headerImage} alt="Header" className="app-item-header-image" />
      </div>
      <div className="app-item-content">{children}</div>
    </div>
  )
}

AppItemComponent.propTypes = {
  headerImage: PropTypes.string.isRequired,
  children: PropTypes.node,
}

export default AppItemComponent
